import type { OutputOptionKey } from './rundown-output.const'

import { OUTPUT_OPTIONS_CONFIG } from './rundown-output.const'

import { useSearchParams } from 'react-router-dom'

export function useRundownOutputOptions() {
  const [searchParams] = useSearchParams()

  /**
   * Function that looks up an Output option in the search params
   * and returns the value or a default value from the config.
   *
   * @throws If an invalid key is passed it will warn at compile time and
   * throw an error at runtime.
   *
   * @example
   *    // The key can be a const or an autocompleted string
   *    getOption(HEADER_POSITION) // Works
   *    getOption('header-position') // Works
   *
   */
  function getOption<K extends OutputOptionKey>(key: K): string {
    const validOption = OUTPUT_OPTIONS_CONFIG[key]
    if (!validOption) throw new Error('Invalid Output option')

    // Lookup option in params
    const value = searchParams.get(key)
    if (value) return value

    // Fallback to default value
    const defaultValue = OUTPUT_OPTIONS_CONFIG[key]?.default
    if (defaultValue) return defaultValue

    // Fallback to empty string
    return ''
  }

  return {
    getOption,
  }
}
